import React from "react";
import { Route } from "react-router-dom";
import useFetchMenu from "Common/FetchAllMenu";
import { CanAccessThisPage } from "Common/RoleVerify";

import LanguageList from "Tuning/Localization/Language/LanguageList/LanguageList";
import TeamList from "Tuning/WebsiteSettings/TeamMembers/TeamMemberList/TeamList";
import GalleryList from "Tuning/WebsiteSettings/Gallery/GalleryList/GalleryList";
import BrandLogoList from "Tuning/WebsiteSettings/BrandLogo/BrandLogoList/BrandLogoList";
import Footer from "Tuning/WebsiteSettings/Footer/FooterList/Footer";
import RoomFeatureList from "Tuning/WebsiteSettings/RoomFeature/RoomFeatureList/RoomFeatureList";
import HomeLayoutList from "Tuning/WebsiteSettings/HomeLayout/HomeLayoutList/HomeLayoutList";
import ContactInformation from "Tuning/WebsiteSettings/ContactInformation/ContactInformactionList/ContactInformation";
import UserList from "Tuning/UserManagement/UserList/UserList";
import HeroSectionList from "Tuning/WebsiteSettings/HomePageHeroSection/HeroSectionList/HeroSectionList";
import RoleList from "Tuning/RoleManagement/RoleList/RoleList/RoleList";
import RolePermission from "Tuning/RoleManagement/RolePermissionList/RolePermissionList";
import RoleAssign from "Tuning/RoleManagement/RoleAssign/RoleAssign";
import EmailSettings from "Tuning/CommunicationSettings/Email/EmailSettings";
import SubscribeEmaillist from "Tuning/CommunicationSettings/SubscribeEmaillist/SubscribeEmaillist";
import MenuList from "Tuning/SystemSettings/FrontMenu/MenuList/MenuList";
import CurrencyList from "Tuning/SystemSettings/CurrencySetting/CurrencyList/CurrencyList";
import CommonSetting from "Tuning/SystemSettings/CommonSetting/CommonSetting";
import SmsSettings from "Tuning/CommunicationSettings/SMS/SmsSettings";
import WebsiteContactRequestsList from "Tuning/WebsiteSettings/WebsiteContactRequests/WebsiteContactRequestsList/WebsiteContactRequestsList";
import BlogList from "Partials/Blog/BlogList/BlogList/BlogList";
import BlogCategoryList from "Partials/Blog/BlogCategory/BlogCategoryList/BlogCategoryList";
import BlogTagList from "Partials/Blog/BlogTag/BlogTagList/BlogTagList";
import BlogCommentList from "Partials/Blog/BlogComment/BlogCommentList/BlogCommentList";
import CommunicationSettings from "Tuning/CommunicationSettings/CommunicationSettings";
import PagesSettings from "Tuning/PagesSettings/PagesSettings";
import NotificationQueueList from "Tuning/NotificationQueue/NotificationQueueList/NotificationQueueList";
import WhyChooseUsList from "Tuning/WhyChooseUs/WhyChooseUsList/WhyChooseUsList";
import AboutUsList from "Partials/Universal/Hotels/AboutUs/AboutUsList/AboutUs"


const tuningComponents = {
    UserList,
    LanguageList,
    EmailSettings,
    SubscribeEmaillist,
    MenuList,
    CurrencyList,
    CommonSetting,
    BrandLogoList,
    TeamList,
    GalleryList,
    ContactInformation,
    RoomFeatureList,
    Footer,
    RolePermission,
    RoleList,
    RoleAssign,
    HomeLayoutList,
    SmsSettings,
    HeroSectionList,
    WebsiteContactRequestsList,
    BlogList,
    BlogCategoryList,
    BlogTagList,
    BlogCommentList,
    CommunicationSettings,
    PagesSettings,
    NotificationQueueList,
    WhyChooseUsList,
    AboutUsList
};

const TuningDynamicRoutes = () => {

    const { menu: tunningMenu } = useFetchMenu("tunning");


    const SpretMenu = tunningMenu?.flatMap((item) => item.children || []);

    return SpretMenu?.map((item, index) => {
        const Component = tuningComponents[item?.component_name];
        if (!Component) {
            return null;
        }
        return (
            <Route
                key={index}
                path={`/${item?.page_url}`}
                element={
                    <CanAccessThisPage menu_access={['can_access', 'can_create', 'can_edit', 'can_delete']} page_url={item?.page_url}>
                        {<Component />}
                    </CanAccessThisPage>
                }
            />
        );
    }).filter(Boolean) || [];
};
export default TuningDynamicRoutes